import React, { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import api from "../../lib/api";
import { formatItalianDateTime } from "../../lib/dateUtils";
import { Card, Spinner, PageGuide } from "../../components/ui-kit";

export default function AuditLog() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/admin/audit").then(({ data }) => setLogs(data.logs)).catch(() => setLogs([])); }, []);
  return (
    <div className="space-y-6" data-testid="audit-page">
      <div><p className="text-xs uppercase tracking-[0.18em] text-slate-400 font-body">Tracciabilità</p><h1 className="font-heading text-3xl font-bold">Audit log</h1></div>
      <PageGuide
        title="Guida rapida: Audit log"
        summary="Un registro in sola lettura delle azioni sensibili svolte sull'app: nessun campo da compilare, serve solo per controlli e verifiche."
        goals={["Consultare chi ha fatto cosa e quando (accessi, modifiche, azioni critiche) per controlli, verifiche e in caso di anomalie."]}
        testid="audit-guide"
      />
      {!logs ? <Spinner /> : (
        <Card className="divide-y divide-hairline">
          {logs.length === 0 && <div className="p-8 text-center text-slate-400"><ScrollText className="w-10 h-10 mx-auto mb-3 opacity-40" />Nessun evento registrato.</div>}
          {logs.map((l) => (
            <div key={l.id} className="p-4 flex items-center gap-4" data-testid={`audit-${l.id}`}>
              <span className={`text-xs px-2 py-1 rounded-full ${l.outcome === "failed" || l.outcome === "locked" ? "bg-red-100 text-red-700" : "bg-emerald-100 text-emerald-700"}`}>{l.action}</span>
              <div className="flex-1 min-w-0">
                <div className="text-sm text-navy truncate">{l.user_email || "—"} <span className="text-slate-400">· {l.entity}</span></div>
                <div className="text-xs text-slate-400">{formatItalianDateTime(l.created_at)}{l.ip ? ` · ${l.ip}` : ""}</div>
              </div>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
